import { ClassroomCSVObject } from "../ClassroomCSVObject";
import { ScheduleCSVEntry } from "./ScheduleCSVObject";

export function getValidCSVFiles(files: File[]): File[] {
  const validFiles: File[] = [];
  for (const file of files) {
    if (file.type) {
      if (
        file.type === "text/csv" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel"
      ) {
        validFiles.push(file);
      }
    } else {
      // Windows 10 and Windows 7 sometimes return an empty string for the file type,
      // so we can check the extension as to whether the file is a csv or not
      if (file.name.endsWith(".csv")) {
        validFiles.push(file);
      }
    }
  }
  return validFiles;
}

export type UniqueClassroomEntries = Record<string, Record<string, string>>;

export function getUniqueClassroomEntryArray(classroomCsvObjects: Set<ClassroomCSVObject>): UniqueClassroomEntries {
  const ret: UniqueClassroomEntries = {};
  for (const csvObj of classroomCsvObjects) {
    for (const [classroom, usersObj] of Object.entries(csvObj.entries)) {
      if (!ret[classroom]) {
        ret[classroom] = {};
      }
      Object.assign(ret[classroom], usersObj);
    }
  }
  return ret;
}

export function readScheduleCSVLineToType(line: string): ScheduleCSVEntry {
  // We want to simply check the number of columns. The backend will validate the data.
  const validColumnCount = 6;

  const entries = line.split(",");

  // Validate that we have exactly 6 columns and none are empty
  if (entries.length !== validColumnCount) {
    throw new Error(`Expected ${validColumnCount} columns per row, got ${entries.length} columns, line: ${line}`);
  }

  // Validate that all entries exist and are not empty
  for (let i = 0; i < validColumnCount; i++) {
    if (entries[i] === undefined || entries[i] === "") {
      throw new Error(`Expected no empty columns per row, got an empty columns on line: ${line}`);
    }
  }

  const classroom_name = entries[0].trim().replace(/['"]+/g, "");
  const teacher_username = entries[1].trim().replace(/['"]+/g, "");
  const day = entries[2].trim().replace(/['"]+/g, "");
  const start_time = entries[3].trim().replace(/['"]+/g, "");
  const end_time = entries[4].trim().replace(/['"]+/g, "");
  const end_date = entries[5].trim().replace(/['"]+/g, "");

  return {
    classroom_name,
    teacher_username,
    day,
    start_time,
    end_time,
    end_date,
  };
}
